/**
 * @flow
 * @relayHash 5146544a99c517a36128b89da446b871
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type testResidentInviteEmailInput = {|
  clientMutationId?: ?string,
  id: string,
  recipients: string,
  subject: string,
  bodyHtml: string,
  bodyPlain?: ?string,
  from?: ?string,
  cc?: ?string,
  bcc?: ?string,
  reply_to?: ?string,
  attachments?: ?string,
  preheader?: ?string,
  prefix?: ?string,
  comment?: ?string,
|};
export type testInviteMutationVariables = {|
  input: testResidentInviteEmailInput
|};
export type testInviteMutationResponse = {|
  +testResidentInviteEmail: ?{|
    +hyreferralCampaign: ?{|
      +id: string,
      +residentInviteCampaignTested: ?boolean,
    |}
  |}
|};
export type testInviteMutation = {|
  variables: testInviteMutationVariables,
  response: testInviteMutationResponse,
|};
*/


/*
mutation testInviteMutation(
  $input: testResidentInviteEmailInput!
) {
  testResidentInviteEmail(input: $input) {
    hyreferralCampaign {
      id
      residentInviteCampaignTested
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "testResidentInviteEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "testResidentInviteEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "testResidentInviteEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyreferralCampaign",
        "storageKey": null,
        "args": null,
        "concreteType": "HyreferralCampaign",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "residentInviteCampaignTested",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "testInviteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "testInviteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "testInviteMutation",
    "id": null,
    "text": "mutation testInviteMutation(\n  $input: testResidentInviteEmailInput!\n) {\n  testResidentInviteEmail(input: $input) {\n    hyreferralCampaign {\n      id\n      residentInviteCampaignTested\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aff8814f26b91c3beaa46182263d755c';
module.exports = node;
